import { graphql, useStaticQuery } from "gatsby";

export interface SiteMetadata {
   siteMetadata: {
      title: string
      siteUrl: string
   }
}
 

const useSiteMetadata = () => {
   const { site } : { site: SiteMetadata } = useStaticQuery(graphql`
      query {
         site {
            siteMetadata {
               title,
               siteUrl
            }
         }
      }
   `);

  return site?.siteMetadata;
}

export default useSiteMetadata;
